import session from "../../api/session";
export const state = {
    loading: false,
    error: false,
    people: [],
    homeBannerData: {},
};

export const mutations = {
    EMPLOYEES_BEGIN(state) {
        state.loading = true;
        state.error = false;
    },
    EMPLOYEES_SUCCESS(state, data) {
        state.loading = false;
        state.error = false;
        state.people = data;
    },
    EMPLOYEES_FAILURE(state) {
        state.loading = false;
        state.error = true;
    },

    PEOPLE_FILTERS_BEGIN(state) {
        state.loading = true;
        state.errors = false;
    },
    PEOPLE_FILTERS_SUCCESS(state, data) {
        state.loading = false;
        state.errors = false;
        state.people = data;
    },

    PEOPLE_FILTERS_FAILURE(state) {
        state.loading = false;
        state.errors = true;
    },

    HOME_BANNER_BEGIN(state) {
        state.loading = true;
        state.errors = false;
    },
    HOME_BANNER_SUCCESS(state, data) {
        state.loading = false;
        state.errors = false;

        state.homeBannerData = data;
    },
    HOME_BANNER_FAILURE(state) {
        state.loading = false;
        state.errors = true;
    },
};

export const getters = {};

export const actions = {
    async fetchHomeBanner({ commit }) {
        commit("HOME_BANNER_BEGIN");
        return await session
            .get("api/home-banner/")
            .then(({ data }) => commit("HOME_BANNER_SUCCESS", data))
            .catch(() => commit("HOME_BANNER_FAILURE"));
    },
    async fetchAllPeople({ commit }) {
        commit("EMPLOYEES_BEGIN");
        return await session
            .get("api/employees/")
            .then(({ data }) => commit("EMPLOYEES_SUCCESS", data))
            .catch(() => commit("EMPLOYEES_FAILURE"));
    },

    async fetchPeopleByFilters({ commit }, { peopleFilters: { currentPage, role, department, person } }) {
        commit("PEOPLE_FILTERS_BEGIN");

        return await session
            .get(
                `api/employees/?page=${currentPage}&${role}&${department}&search_person=${person}`
            )
            .then(({ data }) => commit("PEOPLE_FILTERS_SUCCESS", data))
            .catch(() => commit("PEOPLE_FILTERS_FAILURE"));
    },
};